import getSymbolFromCurrency from "currency-symbol-map";

export function removeCSSClass(ele, cls) {
    const reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
    ele.className = ele.className.replace(reg, " ");
}

export function addCSSClass(ele, cls) {
    ele.classList.add(cls);
}

export const toAbsoluteUrl = pathname => process.env.PUBLIC_URL + pathname;

const withCommas = (value) => {
    const parts = String(value ?? "").split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
};

// Currency-aware price string. HUF renders Hungarian-style: space digit grouping
// + "Ft" prefix with a space (Ft 123 456). Every other currency keeps the existing
// "$123,456" formatting exactly.
export const formatCcmodePrice = (value, currencyCode) => {
    const symbol = getSymbolFromCurrency(currencyCode) || currencyCode || "";
    const amount = Number(value);
    // money is whole-number here; round + guard NaN/Infinity (e.g. total/0 when nothing selected)
    const rounded = Math.round(Number.isFinite(amount) ? amount : 0);
    if (currencyCode === "HUF") {
        const grouped = new Intl.NumberFormat("hu-HU", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(rounded);
        return `${symbol} ${grouped}`;
    }
    return `${symbol}${withCommas(rounded)}`;
};

// node returns the literal "Price on request" for price-on-request items; localize it.
export const localizePrice = (value, language) =>
    value === "Price on request"
        ? (language?.CCMODE_PRICE_ON_REQUEST || value)
        : value;
